import { ProjectManagementState } from '@/store/ProjectManagement/ProjectManagementRoot';
import { ActionTree } from 'vuex';

// API
import {
    getChartVersionStructure,
    getChartById,
    getPMChartDpcExecList,
    getPMChartDpcList,
    getUsersStructure,
    getWeeklyReportById,
    updatePMChart,
} from '@/utils/api/ProjectManagement/PMChart';

import { keeper } from '@/plugins/PromiseKeeper/PromiseKeeper';
import { IPMChart, IPMChartWeeklyReport } from '@/ship/Models/IProjectManagement';
import PMChartEditModel from '@/ship/Models/PMChartEditModel';
import { ChartVersion } from '@/ship/Models/ProjectManagement';
import User from '@/ship/Models/User';
import { GetRequestParams } from '@/ship/Requests/RequestParams';

export const actions: ActionTree<ProjectManagementState, ProjectManagementState> = {
    async GET_CHART_BY_ID({ state, commit }, payload: { id: number; params?: GetRequestParams }): Promise<IPMChart> {
        if (state.chart && state.chart.id == payload.id) return state.chart;

        return keeper.get('getChartById', async () => {
            const {
                data: { data: chart },
            } = await getChartById(payload.id, payload.params);

            commit('SET_CHART', chart);

            return chart;
        });
    },

    async UPDATE_CHART_BY_ID({ state, commit }, payload: { id: number; data: PMChartEditModel }): Promise<IPMChart> {
        return keeper.get('UPDATE_CHART_BY_ID', async () => {
            const {
                data: { data: chart },
            } = await updatePMChart(payload.id, payload.data);

            commit('UPDATE_CHART_BY_ID', chart);

            return chart;
        });
    },

    async GET_DPC_LIST({ commit }, chartId: number) {
        return keeper.get('GET_DPC_LIST', async () => {
            const {
                data: { data: dpcList },
            } = await getPMChartDpcList(chartId);

            commit('SET_DPC_LIST', dpcList);

            return dpcList;
        });
    },

    async GET_DPC_EXEC_LIST({ commit }, chartId: number) {
        return keeper.get('GET_DPC_EXEC_LIST', async () => {
            const {
                data: { data: dpcExecList },
            } = await getPMChartDpcExecList(chartId);

            commit('SET_DPC_EXEC_LIST', dpcExecList);

            return dpcExecList;
        });
    },

    /**
     *
     * @param param0
     * @param id
     * @param isStrict - подразумевает, что можно обходить проверку и при необходимости перезаписывать состояние
     * @returns
     */
    async GET_CHART_VERSION_BY_ID({ state, commit }, id: number, isStrict = true): Promise<ChartVersion> {
        if (state.chartVersion && state.chartVersion.id == id && isStrict) return state.chartVersion;
        return keeper.get('getChartVersionById', async () => {
            const {
                data: { data: chartVersion },
            } = await getChartVersionStructure(id);

            commit('SET_CHART_VERSION', chartVersion);

            return chartVersion;
        });
    },

    async GET_USERS({ commit }): Promise<User[]> {
        return keeper.get('getUsers', async () => {
            const {
                data: { data: users },
            } = await getUsersStructure();

            commit('SET_USERS', users);

            return users;
        });
    },

    async GET_WEEKLY_REPORT({ commit }, id: number): Promise<IPMChartWeeklyReport> {
        return keeper.get('getWeeklyReportById', async () => {
            const {
                data: { data: weeklyReport },
            } = await getWeeklyReportById(id);

            commit('SET_WEEKLY_REPORT', weeklyReport);

            return weeklyReport;
        });
    },
};
export default actions;
